/**
 * Import & export all components fieldsets here, and only here !
 * Please respect the alphabetic order
 */

import { AgencyFieldsetComponent }              from './agency-fieldset/agency-fieldset.component';
import { RemarkFieldsetComponent }              from './remark-fieldset/remark-fieldset.component';
import { CarrierFieldsetModule } from "./carrier-fieldset/carrier-fieldset.module";


/** Export components to module */
export const fieldsetComponents = [
    AgencyFieldsetComponent,
    RemarkFieldsetComponent,
];

export const fieldsetModules = [
    CarrierFieldsetModule,
];
